"use client"
import React,{useEffect,useRef,useState} from 'react'
//import Footer '@/components/Footer';
import Footer from '../components/Footer';
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import { ProductProvider } from '../components/Productcontext';
import Producthomecontent from '../components/Producthomecontent';
import ban1x from  '../images/producthome/product-home-banner.jpg';
import ban2x from  '../images/producthome/product-home-banner@2x.jpg';
import ban3x from  '../images/producthome/product-home-banner_720.jpg';
import bantab from  '../images/producthome/product-home-banner_tab.jpg';
import ProducthomeBanner from '../components/ProducthomeBanner';
// import { useLocation } from 'react-router-dom';

export default function ourservices() {
  const displline=true;

    return (
        <div>
          <ProductProvider>
              {/* <PreHeader/>
              <Header/>
              <Menu/> */}
              <ProducthomeBanner page="product home" banalt="our products" bannertext="" ban1x={ban1x} ban2x={ban2x} ban360={ban3x} bantab={bantab}/> 
              <Producthomecontent/>
                         
              <Footer linedisp={displline}/>
            </ProductProvider>
        </div>
    )

}